import React from "react";
import { useTranslation } from "react-i18next";

import {
  CardHeaderContainer,
  DescBox,
  Row,
  ItemPhoto,
  ItemName,
  ItemPrice,
  SelectedImageContainer,
  SelectedText,
  SelectContainer,
} from "./PackagingComponent.styles";

import SuccessImg from "../../assets/images/success.png";
import { priceFormatter } from "../../utils/utils";

const PackagingComponent = ({ items, selectedPackage, setSelectedPackage }) => {
  const { t } = useTranslation();

  return (
    <>
      {!!items.length &&
        items.map((item) => {
          return (
            <Row
              key={item.id}
              $selected={selectedPackage?.id === item.id}
              onClick={() => {
                setSelectedPackage(item);
              }}
            >
              <CardHeaderContainer>
                <ItemPhoto src={item?.photoUrl} alt="Item-img" />
                <DescBox>
                  <ItemName>{t(`${item?.name}`)}</ItemName>
                  <ItemPrice>
                    {item.price === 0
                      ? `${t("free")} `
                      : `${t("price-per-item")}  ${priceFormatter(
                          item?.price,
                          true,
                          15
                        )} SR`}
                  </ItemPrice>
                </DescBox>
              </CardHeaderContainer>
              {selectedPackage?.id === item.id && (
                <SelectContainer>
                  <SelectedImageContainer src={SuccessImg} alt="success-img" />
                  <SelectedText>{t("selected")}</SelectedText>
                </SelectContainer>
              )}
            </Row>
          );
        })}
    </>
  );
};

export default PackagingComponent;
